import { createSlice } from "@reduxjs/toolkit";
import { generateReport } from "./PeriodicIso.thunk";

const baseState = {
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  retryCount: 0,
  merchantData: null,
  merchantHolding: null,
  consolidatedData: null,
  isoID: null,
  isoName: null,
};

const initialState = {
  ...baseState,
};

export const periodicIsoSlice = createSlice({
  name: "periodicIso",
  initialState,
  reducers: {
    // Reset actions
    ResetStore: (state) => {
      return { ...baseState };
    },
  },
  extraReducers: (builder) => {
    // Create enrollment
    builder
      .addCase(generateReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(generateReport.fulfilled, (state, action) => {
        const {
          retryCount,
          merchantData,
          merchantHolding,
          consolidatedData,
          isoID,
          isoName,
        } = action.payload;
        state.retryCount = retryCount;
        state.merchantData = merchantData;
        state.merchantHolding = merchantHolding;
        state.consolidatedData = consolidatedData;
        state.isoID = isoID;
        state.isoName = isoName;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(generateReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error generating report";
      });
  },
});

export const { ResetStore } = periodicIsoSlice.actions;

export default periodicIsoSlice.reducer;
